<template>
    <ProductionHouseSection
        v-bind="filters"
        :color-theme="colorTheme"
    >
        <template #title>
            {{ title }}
        </template>
    </ProductionHouseSection>
</template>

<script setup lang="ts">
import type { FlexibleProductionHouseBlockFragment } from '~/types/craft-schema';

const props = defineProps<FlexibleProductionHouseBlockFragment>();

const filters = useExtractFiltersFromCraftBundle(props.productionHouseBundle?.[0]);
</script>
